<template>
    <div class="helferReg" ref="root">
        <el-card class="box-card">
            <template #header>
                <div class="logo-header">
                    <span class="ta-left">Deutsches Rotes Kreuz<br>Hurricane Festival 2025<br>Sanitäts- und
                        Rettungsdienst
                    </span>
                    <img src="..//assets/logo-drk.svg" class="logo-image"/>
                </div>
            </template>
            <el-card class="box-card2">
                <template #header>
                    <div class="card-header">
                        <span><h1>Helfer Registrierung</h1></span>
                    </div>
                    <div v-if="isAdminEdit" class="admin-unit-info">
                        <el-alert
                            :title="`Bearbeitung als Admin – Einheit: ${helperUnit || 'unbekannt'} (wird nicht geändert)`"
                            type="info"
                            :closable="false"
                            show-icon
                        />
                    </div>
                    <div v-if="uploadButton">
                        <el-button type="primary" @click="selectFile">Datenblatt laden</el-button>
                        <input type="file" id="upload" ref="file" class="uploadButton" @change="readFile">
                    </div>
                </template>
                <el-collapse v-model="activeNames">
                    <el-collapse-item title="Persönliche Daten" name="1">
                        <el-form
                            label-width="150px"
                            ref="personalForm"
                            :model="personaldata"
                        >
                            <div class="personal">
                                <div>
                                    <el-form-item
                                        label="Vorname"
                                        :rules="rules.firstname"
                                        prop="vorname"
                                    >
                                        <el-input class="textbox" v-model="personaldata.vorname" placeholder="Vorname"/>
                                        <!--                                    <el-input class="textbox" v-model="vorname" placeholder="Vorname"/>-->
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Nachname"
                                        :rules="rules.name"
                                        prop="name"
                                    >
                                        <el-input class="textbox" v-model="personaldata.name" placeholder="Nachname"/>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Geburtsname"
                                        :rules="rules.gebname"
                                        prop="gebname"
                                    >
                                        <el-input class="textbox" v-model="personaldata.gebname"
                                                  placeholder="Geburtsname"/>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Geburtsdatum"
                                        :rules="rules.gebdat"
                                        prop="gebdat"
                                    >
                                        <el-date-picker
                                            class="date"
                                            v-model="personaldata.gebdat"
                                            placeholder="tt.mm.jjjj"
                                            format="DD.MM.YYYY"
                                            value-format="DD.MM.YYYY"
                                        />
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Geburtsort"
                                        :rules="rules.gebtown"
                                        prop="gebort"
                                    >
                                        <el-input class="textbox" v-model="personaldata.gebort"
                                                  placeholder="Geburtsort"/>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Geburtsland"
                                        :rules="rules.gebcountry"
                                        prop="gebcountry"
                                    >
                                        <el-input class="textbox" v-model="personaldata.gebcountry"
                                                  placeholder="Geburtsland"/>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Email"
                                        :rules="rules.email"
                                        prop="email"
                                    >
                                        <el-input v-model="personaldata.email" class="textbox"/>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Ernährung"
                                        prop="essen"
                                    >
                                        <el-radio-group v-model="personaldata.essen" class="ml-4">
                                            <el-radio label="normal" size="large">keine Einschränkung</el-radio>
                                            <el-radio label="glutenfrei" size="large">glutenfrei</el-radio>
                                            <el-radio label="vegan" size="large">vegan</el-radio>
                                            <el-radio label="vegu" size="large">vegan / glutenfrei</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Fachlichqualifikation"
                                        :rules="rules.professsionel"
                                        prop="fuehrung"
                                    >
                                        <el-select v-model="personaldata.professionalValue" class="m-2"
                                                   placeholder="keine"
                                                   size="large" @change="professionalChange">
                                            <el-option
                                                v-for="item in this.professionalOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="dontshow" id="mediquali">
                                    <el-form-item
                                        label="Fachrichtung"
                                        prop="Specialty"
                                    >
                                        <el-input class="textbox" v-model="personaldata.specialty"
                                                  placeholder="Fachrichtung"/>
                                    </el-form-item>
                                    <el-form-item label="Facharzt" prop="facharzt">
                                        <el-switch v-model="personaldata.facharzt"/>
                                    </el-form-item>
                                    <el-form-item label="Notarztqualifikation" prop="notarztQualifikation">
                                        <el-switch v-model="personaldata.notarztQualifikation"/>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Führung RD"
                                        prop="leadershipRD"
                                    >
                                        <el-select v-model="personaldata.leadershipRD" placeholder="keine"
                                                   size="large" clearable>
                                            <el-option
                                                v-for="item in this.leadershipRDOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item
                                        label="Führung KatS"
                                        prop="leadershipKatS"
                                    >
                                        <el-select v-model="personaldata.leadershipKatS" placeholder="keine"
                                                   size="large" clearable>
                                            <el-option
                                                v-for="item in this.leadershipKatSOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form>
                    </el-collapse-item>
                    <el-collapse-item title="Car Pass" name="3">
                        <el-form
                            label-width="150px"
                            ref="carpassForm"
                            :model="carpass"
                        >
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item
                                        label="Kennzeichen"
                                        prop="kennzeichen"
                                    >
                                        <el-input class="textbox" v-model="carpass.kennzeichen"
                                                  placeholder="Kennzeichen"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        label="Typ"
                                        prop="typ"
                                        label-width="50px"
                                    >
                                        <el-select v-model="carpass.typ" class="m-2"
                                                   placeholder="PKW"
                                                   size="large"
                                        >
                                            <el-option
                                                v-for="item in this.carpassOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="1">
                                    <el-button circle @click="clearCarpass('doktw')">
                                        <i class="pi pi-trash"></i>
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-collapse-item>
                    <el-collapse-item title="Einsatzzeiten" name="2">
                        <table class="worktimes">
                            <thead>
                            <tr>
                                <th></th>
                                <th>Tagschicht</th>
                                <th>Nachtschicht</th>
                                <th>Konzertschicht</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    Do. 18.06.2026
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.dofrs">
                                    </el-checkbox>
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.dosps">
                                    </el-checkbox>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>
                                    Fr. 19.06.2026
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.frfrs">
                                    </el-checkbox>
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.frsps">
                                    </el-checkbox>
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.frkos">
                                    </el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Sa. 20.06.2026
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.safrs">
                                    </el-checkbox>
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.sasps">
                                    </el-checkbox>
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.sakos">
                                    </el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    So. 21.06.2026
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.sofrs">
                                    </el-checkbox>
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.sosps">
                                    </el-checkbox>
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.sokos">
                                    </el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Mo. 22.06.2026
                                </td>
                                <td>
                                    <el-checkbox
                                        v-model="worktimes.mofrs">
                                    </el-checkbox>
                                </td>
                                <td>
                                </td>
                                <td>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </el-collapse-item>
                    <el-collapse-item title="Einsatzbereich" name="2">
                        <div>
                            <div>
                                <span>BHP/UHS: </span><el-checkbox v-model="fieldOfApplication.bhp"></el-checkbox>
                                <span>KTW/RTW/NEF: </span><el-checkbox v-model="fieldOfApplication.ktw"></el-checkbox>
                                <span>Zentrale Dienste: </span><el-checkbox v-model="fieldOfApplication.zen"></el-checkbox>
                                <span>Sonstiges: </span><el-checkbox v-model="fieldOfApplication.sonst"></el-checkbox>
                            </div>
                        </div>

                    </el-collapse-item>

                </el-collapse>
                <el-button type="danger" plain @click="back">Abbrechen</el-button>
                <el-button type="primary" @click="savepersonalData">Daten speichern</el-button>
                <!--            <el-button type="primary" @click="showData">Zeige die Daten</el-button>-->
            </el-card>
        </el-card>

    </div>
</template>

<script>
import {ref, reactive, mapWatchers} from 'vue'
import {PDFDocument} from "pdf-lib";
import AuthService from '@/services/AuthService.js';
import Axios from "axios";
import {ElNotification} from "element-plus";
import 'primeicons/primeicons.css';
import { normalizeProfessional, normalizeLeadership, normalizeEating } from '@/utils/normalize.js';


export default {
    name: 'HelferEingabe',
    data() {
        return {
            radio1: ref('1'),
            uploadButton: true,
            activeNames: ref(['1', '2']),
            leadershipRDOptions: [
                {value: 'gf', label: 'Gruppenführer'},
                {value: 'zf', label: 'Zugführer'},
                {value: 'orgl', label: 'OrgL'}
            ],
            leadershipKatSOptions: [
                {value: 'gf', label: 'Gruppenführer'},
                {value: 'zf', label: 'Zugführer'},
                {value: 'vf', label: 'Verbandsführer'}
            ],
            carpassOptions: [
                {value: '0', label: 'PKW'},
                {value: '1', label: 'MTW'},
                {value: '2', label: 'KTW/RTW'},
                {value: '3', label: 'GW'},
                {value: '4', label: 'LKW'},
                {value: '5', label: 'Sonstiges'},
            ],
            professionalValue: ref(''),
            professionalOptions: [
                {value: 'eh', label: 'Erste Hilfe'},
                {value: 'san', label: 'San'},
                {value: 'rh', label: 'Rettungshelfer'},
                {value: 'rs', label: 'Rettungssanitäter'},
                {value: 'ra', label: 'Rettungsassistent'},
                {value: 'nfs', label: 'Notfallsanitäter'},
                {value: 'arzt', label: 'Arzt'}
            ],
            rules: {
                firstname: [{required: true, message: 'Bitte den Vornamen eintragen', trigger: ['blur', 'change']}],
                name: [{required: true, message: 'Bitte den Nachnamen eintragen', trigger: ['blur', 'change']}],
                email: [{required: true, message: 'Bitte eine E-Mailadresse angeben', trigger: ['blur', 'change']},
                    {type: 'email', message: 'Bitte eine gültige E-Mailadresse angeben', trigger: ['blur', 'change']}],
                gebdat: [{required: true, message: 'Bitte das Geburtsdatum eintragen', trigger: ['blur', 'change']}],
                gebtown: [{required: true, message: 'Bitte das Geburtsort eintragen', trigger: ['blur', 'change']}],
                gebcountry: [{required: true, message: 'Bitte das Geburtsland eintragen', trigger: ['blur', 'change']}],
                fuehrung: [{required: false, message: '', trigger: ['blur', 'change']}],
                professsionel: [{required: false, message: '', trigger: ['blur', 'change']}],
                gebname: [{required: true, message: 'Bitte das Geburtsname eintragen', trigger: ['blur', 'change']}]
            },
            personalForm: {
                vorname: null,
                name: null,
                email: null,
                gebdat: null,
                gebort: null,
                gebname: null,
                essen: null,
                Specialty: null,
                professionalValue: null,
                leadershipRD: null,
                leadershipKatS: null,
                facharzt: false,
                notarztQualifikation: false
            },
            carpassForm: {
                kennzeichen: null,
                typ: null,
                personalID: null
            },
            tableColumn: [
                {lable: 'Datum', prop: 'date', id: 0},
                {lable: 'Frühstück', prop: '', id: 'fr'},
                {lable: 'Mittag', prop: '', id: 'mi'},
                {lable: 'Abned', prop: '', id: 'ab'},
                {lable: 'Nacht', prop: '', id: 'na'},
            ],
            tableData: [
                {date: 'Do. 18.06.2026', id: 'do'},
                {date: 'Fr. 19.06.2026', id: 'fr'},
                {date: 'Sa. 20.06.2026', id: 'sa'},
                {date: 'So. 21.06.2026', id: 'so'},
                {date: 'Mo. 22.06.2026', id: 'mo'}
            ],
            timeColumn: [
                {lable: '', prop: 'date', id: 0},
                {lable: 'Tagschicht', prop: '', id: 'frs'},
                {lable: 'Nachtschicht', prop: '', id: 'sps'},
                {lable: 'Konzertschicht', prop: '', id: 'kos'}
            ],
            personaldata: reactive({
                vorname: null,
                name: null,
                email: null,
                gebdat: null,
                gebort: null,
                gebcountry: null,
                gebname: null,
                essen: 'normal',
                specialty: null,
                professionalValue: null,
                leadershipRD: null,
                leadershipKatS: null,
                facharzt: false,
                notarztQualifikation: false,
                id: null
            }),
            carpass: reactive({
                kennzeichen: null,
                typ: null,
                personalID: null
            }),
            mealtimes: reactive({
                dofr: false, domi: false, doab: false, dona: false, frfr: false,
                frmi: false, frab: false, frna: false, safr: false, sami: false,
                saab: false, sana: false, sofr: false, somi: false, soab: false,
                sona: false, mofr: false, momi: false, moab: false, mona: false
            }),
            worktimes: reactive({
                dofrs: false, dosps: false, dokos: false, doktw: 2,
                frfrs: false, frsps: false, frkos: false, frktw: 2,
                safrs: false, sasps: false, sakos: false, saktw: 2,
                sofrs: false, sosps: false, sokos: false, soktw: 2,
                mofrs: false, mosps: false, mokos: false, moktw: 2,
            }),
            fieldOfApplication: reactive({
                bhp: false,
                ktw: false,
                zen: false,
                sonst: false
            }),
            personal: {},
            worktime: {},
            meeltime: {},
            helperUnit: null,
        }
    },
    computed: {
        isAdminEdit() {
            return this.$route.name === 'AdminHelferBearbeiten';
        },
        apiBase() {
            return this.isAdminEdit
                ? `${process.env.VUE_APP_API_URL}/api/admin`
                : `${process.env.VUE_APP_API_URL}/api`;
        },
    },
    async created() {
        if (!this.$store.getters.isLoggedIn) {
            this.$router.push('/');
        }
        if (Object.keys(this.$route.params).length !== 0) {
            this.uploadButton = false;
            this.id = this.$route.params.id;
            this.loadPersonal(this.id);
            this.loadWorktime(this.id);
            this.loadCarpass(this.id);
        }
    },
    methods: {
        clearSelection: function (key) {
            this.worktimes[key] = 2;
        },

        professionalChange: function (index, resetFields = true) {
            const elem = document.getElementById('mediquali');
            if (index === 'arzt') {
                elem.classList.remove('dontshow');
            } else {
                if (!elem.classList.contains('dontshow')) {
                    elem.classList.add('dontshow');
                }
                if (resetFields) {
                    this.personaldata.specialty = null;
                    this.personaldata.facharzt = false;
                    this.personaldata.notarztQualifikation = false;
                }
            }
        },

        async readFile() {
            const url = (window.URL || window.webkitURL).createObjectURL(this.$refs.file.files[0]);
            const response = await fetch(url);
            const buffer = await response.arrayBuffer();
            const pdfDoc = await PDFDocument.load(buffer);
            const form = pdfDoc.getForm();
            const fields = form.getFields();
            const tfields = fields.map(field => ({
                name: field.getName(),
                value: this.getText(field),
                type: field.constructor.name
            }));
            console.log(tfields);
            this.mapData(tfields);
        },

        getText: function (field) {
            if (typeof field.isChecked === 'function') {
                return field.isChecked();
            }
            if (typeof field.getText === 'function') {
                return field.getText();
            }
            if (typeof field.getSelected === 'function') {
                const selected = field.getSelected();
                return Array.isArray(selected) ? selected[0] : selected;
            }
            return undefined;
        },

        selectFile: function () {
            const input = document.getElementById('upload');
            input.click();
        },

        mapData: function (data) {
            const me = this;
            data.forEach(function (item) {
                console.log(item);
                switch (item.name) {
                    case 'vorname':
                        me.personaldata.vorname = item.value;
                        break;
                    case 'name':
                        me.personaldata.name = item.value;
                        break;
                    case 'gebname':
                        me.personaldata.gebname = item.value;
                        break;
                    case 'gebdat':
                        me.personaldata.gebdat = item.value;
                        break;
                    case 'gebort':
                        me.personaldata.gebort = item.value;
                        break;
                    case 'gebcountry':
                        me.personaldata.gebcountry = item.value;
                        break;
                    case 'essen':
                        me.personaldata.essen = item.value;
                        break;
                    case 'quali':
                        me.personaldata.professionalValue = item.value;
                        me.professionalChange(item.value);
                        break;
                    case 'fuehrungRD':
                        me.personaldata.leadershipRD = item.value;
                        break;
                    case 'fuehrungKatS':
                        me.personaldata.leadershipKatS = item.value;
                        break;
                    case 'email':
                        me.personaldata.email = item.value;
                        break;
                    case 'fach':
                        me.personaldata.specialty = item.value;
                        break;
                    case 'facharzt':
                        me.personaldata.facharzt = !!item.value;
                        break;
                    case 'notarzt':
                        me.personaldata.notarztQualifikation = !!item.value;
                        break;
                    case 'dota':
                        me.worktimes.dofrs = item.value;
                        if (item.value) {
                            me.mealtimes.dofr = item.value;
                            me.mealtimes.domi = item.value;
                            me.mealtimes.doab = item.value;
                        }
                        break;
                    case 'dona':
                        me.worktimes.dosps = item.value;
                        if (item.value) {
                            me.mealtimes.doab = item.value;
                            me.mealtimes.dona = item.value;
                            me.mealtimes.frfr = item.value;
                        }
                        break;
                    case 'frta':
                        me.worktimes.frfrs = item.value;
                        if (item.value) {
                            me.mealtimes.frfr = item.value;
                            me.mealtimes.frmi = item.value;
                            me.mealtimes.frab = item.value;
                        }
                        break;
                    case
                    'frna':
                        me.worktimes.frsps = item.value;
                        if (item.value) {
                            me.mealtimes.frab = item.value;
                            me.mealtimes.frna = item.value;
                            me.mealtimes.safr = item.value;
                        }
                        break;
                    case 'frko':
                        me.worktimes.frkos = item.value;
                        if (item.value) {
                            me.mealtimes.frmi = item.value;
                            me.mealtimes.frab = item.value;
                            me.mealtimes.frna = item.value;
                        }
                        break;
                    case 'sata':
                        me.worktimes.safrs = item.value;
                        if (item.value) {
                            me.mealtimes.safr = item.value;
                            me.mealtimes.sami = item.value;
                            me.mealtimes.saab = item.value;
                        }
                        break;
                    case 'sana':
                        me.worktimes.sasps = item.value;
                        if (item.value) {
                            me.mealtimes.saab = item.value;
                            me.mealtimes.sana = item.value;
                            me.mealtimes.sofr = item.value;
                        }
                        break;
                    case 'sako':
                        me.worktimes.sakos = item.value;
                        if (item.value) {
                            me.mealtimes.sami = item.value;
                            me.mealtimes.saab = item.value;
                            me.mealtimes.sana = item.value;
                        }
                        break;
                    case 'sota':
                        me.worktimes.sofrs = item.value;
                        if (item.value) {
                            me.mealtimes.sofr = item.value;
                            me.mealtimes.somi = item.value;
                            me.mealtimes.soab = item.value;
                        }
                        break;
                    case 'sona':
                        me.worktimes.sosps = item.value;
                        if (item.value) {
                            me.mealtimes.soab = item.value;
                            me.mealtimes.sona = item.value;
                            me.mealtimes.mofr = item.value;
                        }
                        break;
                    case 'soko':
                        me.worktimes.sokos = item.value;
                        if (item.value) {
                            me.mealtimes.somi = item.value;
                            me.mealtimes.soab = item.value;
                            me.mealtimes.sona = item.value;
                        }
                        break;
                    case 'mota':
                        me.worktimes.mofrs = item.value;
                        if (item.value) {
                            me.mealtimes.mofr = item.value;
                        }
                        break;
                    case 'doktw':
                        switch (item.value) {
                            case 'No':
                            case '0':
                                me.worktimes.doktw = 0;
                                break;
                            case 'Yes':
                            case '1':
                                me.worktimes.doktw = 1;
                                break;
                            default:
                                me.worktimes.doktw = 2;
                        }
                        break;
                    case 'frktw':
                        switch (item.value) {
                            case 'No':
                            case '0':
                                me.worktimes.frktw = 0;
                                break;
                            case 'Yes':
                            case '1':
                                me.worktimes.frktw = 1;
                                break;
                            default:
                                me.worktimes.frktw = 2;
                        }
                        break;
                    case 'saktw':
                        switch (item.value) {
                            case 'No':
                            case '0':
                                me.worktimes.saktw = 0;
                                break;
                            case 'Yes':
                            case '1':
                                me.worktimes.saktw = 1;
                                break;
                            default:
                                me.worktimes.saktw = 2;
                        }
                        break;
                    case 'soktw':
                        switch (item.value) {
                            case 'No':
                            case '0':
                                me.worktimes.soktw = 0;
                                break;
                            case 'Yes':
                            case '1':
                                me.worktimes.soktw = 1;
                                break;
                            default:
                                me.worktimes.soktw = 2;
                        }
                        break;
                    case 'moktw':
                        switch (item.value) {
                            case 'No':
                            case '0':
                                me.worktimes.moktw = 0;
                                break;
                            case 'Yes':
                            case '1':
                                me.worktimes.moktw = 1;
                                break;
                            default:
                                me.worktimes.moktw = 2;
                        }
                        break;
                    case 'bhp':
                        me.fieldOfApplication.bhp = item.value;
                        break;
                    case 'ktw':
                        me.fieldOfApplication.ktw = item.value;
                        break;
                    case 'zend':
                        me.fieldOfApplication.zen = item.value;
                        break;
                    case 'sonst':
                        me.fieldOfApplication.sonst = item.value;
                        break;
                    default:
                }
            })
            console.log(me.worktimes);
            console.log(me.mealtimes);
        },

        savepersonalData() {
            const me = this;

            // Validierung der Pflichtfelder
            const errors = [];
            if (!me.personaldata.vorname || me.personaldata.vorname.trim() === '') {
                errors.push('Vorname');
            }
            if (!me.personaldata.name || me.personaldata.name.trim() === '') {
                errors.push('Nachname');
            }
            if (!me.personaldata.gebname || me.personaldata.gebname.trim() === '') {
                errors.push('Geburtsname');
            }
            if (!me.personaldata.gebdat) {
                errors.push('Geburtsdatum');
            }
            if (!me.personaldata.gebort || me.personaldata.gebort.trim() === '') {
                errors.push('Geburtsort');
            }
            if (!me.personaldata.gebcountry || me.personaldata.gebcountry.trim() === '') {
                errors.push('Geburtsland');
            }
            if (!me.personaldata.email || me.personaldata.email.trim() === '') {
                errors.push('E-Mail');
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(me.personaldata.email)) {
                ElNotification({
                    title: 'Ungültige E-Mail',
                    message: 'Bitte eine gültige E-Mail-Adresse eingeben',
                    type: 'error',
                });
                return;
            }

            if (errors.length > 0) {
                ElNotification({
                    title: 'Fehlende Pflichtfelder',
                    message: 'Bitte folgende Felder ausfüllen: ' + errors.join(', '),
                    type: 'error',
                    duration: 5000
                });
                return;
            }

            let url = `${this.apiBase}/personaldata`
            if (this.id) {
                url = `${this.apiBase}/personaldata/${this.id}`;
            }
            let teile = me.personaldata.gebdat.split(".");
            let jahr = parseInt(teile[2], 10);
            let monat = parseInt(teile[1], 10) - 1;
            let tag = parseInt(teile[0], 10);
            const tdate = new Date(jahr, monat, tag);
            const payload = {
                firstname: me.personaldata.vorname,
                name: me.personaldata.name,
                email: me.personaldata.email,
                birthdate: tdate.getFullYear() + '-' + Number(tdate.getMonth() + 1) + '-' + tdate.getDate(),
                birthtown: me.personaldata.gebort,
                birthcountry: me.personaldata.gebcountry,
                birthname: me.personaldata.gebname,
                eating: me.personaldata.essen,
                Specialty: me.personaldata.specialty ? me.personaldata.specialty : 'keine',
                professionalValue: me.personaldata.professionalValue,
                leadershipRD: me.personaldata.leadershipRD,
                leadershipKatS: me.personaldata.leadershipKatS,
                facharzt: me.personaldata.facharzt ? 1 : 0,
                notarztQualifikation: me.personaldata.notarztQualifikation ? 1 : 0,
                bhp: me.fieldOfApplication.bhp,
                ktw: me.fieldOfApplication.ktw,
                zen: me.fieldOfApplication.zen,
                sonst: me.fieldOfApplication.sonst
            };
            // Im Admin-Edit wird die Einheit bewusst nicht mitgeschickt – das Backend
            // erhält die ursprüngliche Zuordnung des Helfers.
            if (!this.isAdminEdit) {
                payload.unit = me.$store.getters.getUnit;
            }
            Axios.post(url, payload)
                .then(response => {
                    console.log(response.data);
                    this.saveWorkTimes(response.data.data.id);
                })
                .catch(error => {
                    console.log(error);
                    let errorMessage = 'Speichern fehlgeschlagen';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    ElNotification({
                        title: 'Fehler beim Speichern',
                        message: errorMessage,
                        type: 'error',
                        duration: 5000
                    });
                });
        },

        saveWorkTimes(id) {
            const me = this;
            Axios.post(`${process.env.VUE_APP_API_URL}/api/worktimes`, {
                personal: id,
                doda: me.worktimes.dofrs,
                doni: me.worktimes.dosps,
                doco: me.worktimes.dokos,
                dokt: me.worktimes.doktw,
                frda: me.worktimes.frfrs,
                frni: me.worktimes.frsps,
                frco: me.worktimes.frkos,
                frkt: me.worktimes.frktw,
                sada: me.worktimes.safrs,
                sani: me.worktimes.sasps,
                saco: me.worktimes.sakos,
                sakt: me.worktimes.saktw,
                soda: me.worktimes.sofrs,
                soni: me.worktimes.sosps,
                soco: me.worktimes.sokos,
                sokt: me.worktimes.soktw,
                moda: me.worktimes.mofrs,
                moni: me.worktimes.mosps,
                moco: me.worktimes.mokos,
                mokt: me.worktimes.moktw
            })
                .then(response => {
                    console.log(response.data);
                    this.saveMealTimes(id);
                })
                .catch(error => {
                    console.log(error);
                    ElNotification({
                        title: 'Fehler beim Speichern der Arbeitszeiten',
                        message: error.response?.data?.message || 'Speichern der Einsatzzeiten fehlgeschlagen',
                        type: 'error',
                        duration: 5000
                    });
                });
        },

        async saveMealTimes(id) {
            await this.calculateMealtimes();
            const me = this;
            Axios.post(`${process.env.VUE_APP_API_URL}/api/mealtimes`, {
                personal: id,
                dobr: me.mealtimes.dofr,
                dolu: me.mealtimes.domi,
                dodi: me.mealtimes.doab,
                dode: me.mealtimes.dona,
                frbr: me.mealtimes.frfr,
                frlu: me.mealtimes.frmi,
                frdi: me.mealtimes.frab,
                frde: me.mealtimes.frna,
                sabr: me.mealtimes.safr,
                salu: me.mealtimes.sami,
                sadi: me.mealtimes.saab,
                sade: me.mealtimes.sana,
                sobr: me.mealtimes.sofr,
                solu: me.mealtimes.somi,
                sodi: me.mealtimes.soab,
                sode: me.mealtimes.sona,
                mobr: me.mealtimes.mofr,
                molu: me.mealtimes.momi,
                modi: me.mealtimes.moab,
                mode: me.mealtimes.mona,
            })
                .then(response => {
                    console.log(response.data);
                    me.saveCarpass(id);
                })
                .catch(error => {
                    console.log(error);
                    ElNotification({
                        title: 'Fehler beim Speichern der Essenszeiten',
                        message: error.response?.data?.message || 'Speichern der Essenszeiten fehlgeschlagen',
                        type: 'error',
                        duration: 5000
                    });
                });
        },

        saveCarpass: function (id) {
            const me = this;
            if (me.carpass.kennzeichen !== null) {
                const carpassUrl = this.isAdminEdit
                    ? `${process.env.VUE_APP_API_URL}/api/admin/carpass`
                    : `${process.env.VUE_APP_API_URL}/api/carpass`;
                Axios.post(carpassUrl, {
                    personalID: id,
                    kennzeichen: me.carpass.kennzeichen,
                    typ: me.carpass.typ || 5
                })
                    .then(response => {
                        console.log(response.data);
                        me.navigateBack();
                    })
                    .catch(error => {
                        console.log(error);
                        ElNotification({
                            title: 'Fehler beim Speichern des Car Pass',
                            message: error.response?.data?.message || 'Speichern des Car Pass fehlgeschlagen',
                            type: 'error',
                            duration: 5000
                        });
                    });

            } else {
                me.navigateBack();
            }
        },

        navigateBack() {
            this.$router.push(this.isAdminEdit ? '/admin/helfer' : '/unitdashboard');
        },

        async calculateMealtimes() {
            const me = this;
            me.resetMealtimes();
            for (const [key, item] of Object.entries(me.worktimes)) {
                switch (key) {
                    case 'dofrs':
                        if (item) {
                            me.mealtimes.dofr = true;
                            me.mealtimes.domi = true;
                            me.mealtimes.doab = true;
                        }
                        break;
                    case 'dosps':
                        if (item) {
                            me.mealtimes.doab = true;
                            me.mealtimes.dona = true;
                            me.mealtimes.frfr = true;
                        }
                        break;
                    case 'dokos':
                        if (item) {
                            me.mealtimes.domi = true;
                            me.mealtimes.doab = true;
                            me.mealtimes.dona = true;
                        }
                        break;
                    case 'frfrs':
                        if (item) {
                            me.mealtimes.frfr = true;
                            me.mealtimes.frmi = true;
                            me.mealtimes.frab = true;
                        }
                        break;
                    case 'frsps':
                        if (item) {
                            me.mealtimes.frab = true;
                            me.mealtimes.frna = true;
                            me.mealtimes.safr = true;
                        }
                        break;
                    case 'frkos':
                        if (item) {
                            me.mealtimes.frmi = true;
                            me.mealtimes.frab = true;
                            me.mealtimes.frna = true;
                        }
                        break;
                    case 'safrs':
                        if (item) {
                            me.mealtimes.safr = true;
                            me.mealtimes.sami = true;
                            me.mealtimes.saab = true;
                        }
                        break;
                    case 'sasps':
                        if (item) {
                            me.mealtimes.saab = true;
                            me.mealtimes.sana = true;
                            me.mealtimes.sofr = true;
                        }
                        break;
                    case 'sakos':
                        if (item) {
                            me.mealtimes.sami = true;
                            me.mealtimes.saab = true;
                            me.mealtimes.sana = true;
                        }
                        break;
                    case 'sofrs':
                        if (item) {
                            me.mealtimes.sofr = true;
                            me.mealtimes.somi = true;
                            me.mealtimes.soab = true;
                        }
                        break;
                    case 'sosps':
                        if (item) {
                            me.mealtimes.soab = true;
                            me.mealtimes.sona = true;
                            me.mealtimes.mofr = true;
                        }
                        break;
                    case 'sokos':
                        if (item) {
                            me.mealtimes.somi = true;
                            me.mealtimes.soab = true;
                            me.mealtimes.sona = true;
                        }
                        break;
                    case 'mofrs':
                        if (item) {
                            me.mealtimes.mofr = true;
                            me.mealtimes.momi = true;
                            me.mealtimes.moab = true;
                        }
                        break;
                    case 'mosps':
                        if (item) {
                            me.mealtimes.moab = true;
                            me.mealtimes.mona = true;
                        }
                        break;
                    case 'mokos':
                        if (item) {
                            me.mealtimes.momi = true;
                            me.mealtimes.moab = true;
                            me.mealtimes.mona = true;
                        }
                        break;
                }
            }
        },

        resetMealtimes() {
            const me = this;
            for (const [key] of Object.entries(me.mealtimes)) {
                me.mealtimes[key] = false;
            }
        },

        loadPersonal: function (id) {
            const me = this;
            Axios.get(`${this.apiBase}/personaldata/${id}`)
                .then(response => {
                    let teile = response.data.data[0].birthdate.split("-");
                    let jahr = teile[0];
                    let monat = teile[1];
                    let tag = teile[2];
                    me.personaldata.vorname = response.data.data[0].firstname;
                    me.personaldata.name = response.data.data[0].name;
                    me.personaldata.email = response.data.data[0].email;
                    me.personaldata.gebdat = tag + '.' + monat + '.' + jahr;
                    me.personaldata.gebort = response.data.data[0].birthtown;
                    me.personaldata.gebcountry = response.data.data[0].birthcountry;
                    me.personaldata.gebname = response.data.data[0].birthname;
                    me.personaldata.essen = normalizeEating(response.data.data[0].eating) || response.data.data[0].eating;
                    me.personaldata.specialty = response.data.data[0].Specialty;
                    me.personaldata.professionalValue = normalizeProfessional(response.data.data[0].professionalValue);
                    me.personaldata.leadershipRD = normalizeLeadership(response.data.data[0].leadershipRD);
                    me.personaldata.leadershipKatS = normalizeLeadership(response.data.data[0].leadershipKatS);
                    me.personaldata.facharzt = !!response.data.data[0].facharzt;
                    me.personaldata.notarztQualifikation = !!response.data.data[0].notarztQualifikation;
                    me.$nextTick(() => me.professionalChange(me.personaldata.professionalValue, false));
                    me.fieldOfApplication.bhp = response.data.data[0].bhp  === 1 ? true : false;
                    me.fieldOfApplication.ktw = response.data.data[0].ktw === 1 ? true : false;
                    me.fieldOfApplication.zen = response.data.data[0].zen === 1 ? true : false;
                    me.fieldOfApplication.sonst = response.data.data[0].sonst === 1 ? true : false;
                    me.helperUnit = response.data.data[0].unit;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        loadWorktime: function (id) {
            const me = this;
            const params = this.isAdminEdit ? {} : { unit: me.$store.getters.getUnit };
            Axios.get(`${this.apiBase}/personalworkdata/${id}`, { params })
                .then(response => {
                    me.worktimes.dofrs = response.data.data[0].doda === 1;
                    me.worktimes.dosps = response.data.data[0].doni === 1;
                    me.worktimes.dokos = response.data.data[0].doco === 1;
                    me.worktimes.doktw = response.data.data[0].dokt;
                    me.worktimes.frfrs = response.data.data[0].frda === 1;
                    me.worktimes.frsps = response.data.data[0].frni === 1;
                    me.worktimes.frkos = response.data.data[0].frco === 1;
                    me.worktimes.frktw = response.data.data[0].frkt;
                    me.worktimes.safrs = response.data.data[0].sada === 1;
                    me.worktimes.sasps = response.data.data[0].sani === 1;
                    me.worktimes.sakos = response.data.data[0].saco === 1;
                    me.worktimes.saktw = response.data.data[0].sakt;
                    me.worktimes.sofrs = response.data.data[0].soda === 1;
                    me.worktimes.sosps = response.data.data[0].soni === 1;
                    me.worktimes.sokos = response.data.data[0].soco === 1;
                    me.worktimes.soktw = response.data.data[0].sokt;
                    me.worktimes.mofrs = response.data.data[0].moda === 1;
                    me.worktimes.mosps = response.data.data[0].moni === 1;
                    me.worktimes.mokos = response.data.data[0].moco === 1;
                    me.worktimes.moktw = response.data.data[0].mokt;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        loadCarpass: function (id) {
            const me = this;
            Axios.get(`${this.apiBase}/carpass/${id}`)
                .then(response => {
                    me.carpass.kennzeichen = response.data.data[0].kennzeichen;
                    me.carpass.typ = response.data.data[0].typ;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        back() {
            this.navigateBack();
        },

        clearCarpass: function () {
            let me = this;
            me.carpass.kennzeichen = null;
            me.carpass.typ = null;
        },

    },
    watch: {

        'worktimes.doktw': function (newVal, oldVal) {
            const me = this;
            if (newVal && !me.worktimes.dofrs && !me.worktimes.dosps && !me.worktimes.dokos) {
                me.worktimes.doktw = oldVal;
                ElNotification({
                    title: 'Fehler',
                    message: 'Es muss mindestens eine Schicht ausgewählt werden',
                    type: 'error',
                });
            }
        }

        /*    'worktimes.dofrs': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.dosps = false;*/
        /*        }*/
        /*    },*/
        /*    'worktimes.dosps': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.dofrs = false;*/
        /*        }*/
        /*    },*/
        /*    'worktimes.frfrs': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.frsps = false;*/
        /*            this.worktimes.frkos = false;*/
        /*        }*/
        /*    },*/
        /*    'worktimes.frsps': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.frfrs = false;*/
        /*            this.worktimes.frkos = false;*/
        /*        }*/
        /*    }, 'worktimes.frkos': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.frsps = false;*/
        /*            this.worktimes.frfrs = false;*/
        /*        }*/
        /*    },*/
        /*    'worktimes.safrs': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.sasps = false;*/
        /*            this.worktimes.sakos = false;*/
        /*        }*/
        /*    },*/
        /*    'worktimes.sasps': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.safrs = false;*/
        /*            this.worktimes.sakos = false;*/
        /*        }*/
        /*    }, 'worktimes.sakos': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.sasps = false;*/
        /*            this.worktimes.safrs = false;*/
        /*        }*/
        /*    },*/
        /*    'worktimes.sofrs': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        /*            this.worktimes.sosps = false;*/
        /*            this.worktimes.sokos = false;*/
        /*        }*/
        /*    },*/
        /*    'worktimes.sosps': function (newVal, oldVal) {*/
        /*        if (newVal) {*/
        //             this.worktimes.sofrs = false;
        //             this.worktimes.sokos = false;
        //         }
        //     },
        //     'worktimes.sokos': function (newVal, oldVal) {
        //         if (newVal) {
        //             this.worktimes.sosps = false;
        //             this.worktimes.sofrs = false;
        //         }
        //     }
    },

};

</script>

<style scoped>
.box-card {
    width: 740px;
    align-content: center;
}

.helferReg {
    display: flex;
    align-items: center;
    justify-content: center;
}

.textbox {
    width: 550px
}

.personal {
    display: flex;
    flex-wrap: wrap;
}

.prefixText {
    width: 120px;
    display: inline-flex;
}

.textbox {
    width: 490px;
}

.dontshow {
    display: none;
}

.worktimes {
    width: 100%;
    font-size: 14px;
    line-height: 32px;
}

.radiolable {
    display: inline-flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex: 0 0 auto;
    font-size: var(--el-form-label-font-size);
    color: var(--el-text-color-regular);
    height: 32px;
    line-height: 32px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    width: 150px
}

.el-radio {
    margin-right: 18px;
}

.uploadButton {
    display: none;
}

.logo-image {
    width: 200px;
    display: flex;
}

.logo-header {
    justify-content: space-between;
    display: flex;
}

.ta-left {
    text-align: left;
}

</style>
